"use strict";

angular
    .module('rmEPG')
    .filter('presenters', function () {

        return function (input) {

            if (!Array.isArray(input)) {
                return '';
            }

            let names = input.map(presenter => {

                return presenter.firstname + ' ' + presenter.lastname;
            });

            return names.join(', ');
        };
    }).filter('fancyTime', function () {
        let zeroPad = (num) => {
            return ('00' + num).substr(-2, 2);
        };
        return (input) => {
            let minutes = Math.floor(input / 60), seconds = input % 60;
            return zeroPad(minutes) + ':' + zeroPad(seconds);
        };
    })
    .filter('nl2br', function ($sce) {
        return (input) => {
            if (input !== void 0) {
                // Potentially unsafe?
                return $sce.trustAsHtml(input.replace(/\n/g, '<br>'));
            }
        };
    });
